import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController, NavParams } from '@ionic/angular';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-connect-jsm-instance-modal',
  templateUrl: './connect-jsm-instance-modal.component.html',
})
export class ConnectJsmInstanceModalComponent {
  instanceName: string;

  constructor(
    private modalCtrl: ModalController,
    navParams: NavParams,
  ) {
    // Pre-populate for reconnect flow
    this.instanceName = navParams.get('instanceName') || '';
  }

  submit() {
    if (!this.instanceName || !this.instanceName.trim()) {
      return;
    }

    this.modalCtrl.dismiss({ instanceName: this.instanceName.trim() });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
